import React from "react";
import UserForgotPassword from "../components/Login/UserForgotPassword";

const UserForgotPasswordPage = () => {
  return (
    <div>
      <UserForgotPassword />
    </div>
  );
};

export default UserForgotPasswordPage;
